import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from 'store/store';
import { withBasePath } from '_config/basePath';

export interface User {
  firstname: string
  lastname: string
  email: string
}

export interface LoginResponse {
  token: string
  claims?: { sub: string; is_prof: boolean; user_type: number }
}

export interface LoginRequest {
  email: string
  password: string
  role?: 'student' | 'advisor'
}

export interface SignupRequest extends LoginRequest {
  firstname: string
  lastname: string
  id?: string
}

export interface ResetPasswordRequest {
  token: string
  new_password: string
}

export interface GenerateResetPasswordTokenRequest {
  email: string
}

export const prepareAuthHeaders = (headers, { getState }) => {
  const token = (getState() as RootState).auth.token
  if (token && token !== 'cookie') {
    headers.set('authorization', `Bearer ${token}`);
  }
  return headers;
}

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: withBasePath('/api/auth'),
    prepareHeaders: prepareAuthHeaders,
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: 'login',
        method: 'POST',
        body: credentials,
      }),
    }),
    signup: builder.mutation<LoginResponse, SignupRequest>({
      query: (credentials) => ({
        url: 'signup',
        method: 'POST',
        body: credentials,
      }),
    }),
    confirm: builder.mutation<any, any>({
      query: (token) => ({
        url: 'confirm',
        method: 'POST',
        body: { token },
      }),
    }),
    resendConfirmation: builder.mutation<any, void>({
      query: () => ({
        url: 'resend-confirmation',
        method: 'POST',
      }),
    }),
    generateResetPasswordToken: builder.mutation<null, GenerateResetPasswordTokenRequest>({
      query: (body) => ({
        url: 'generate_reset_password_token',
        method: 'POST',
        body: body,
      }),
    }),
    resetPassword: builder.mutation<null, ResetPasswordRequest>({
      query: (body) => ({
        url: 'reset_password',
        method: 'POST',
        body: body,
      }),
    }),
  }),
})

export const { useLoginMutation, useSignupMutation, useGenerateResetPasswordTokenMutation, useResetPasswordMutation, useConfirmMutation, useResendConfirmationMutation } = authApi

export const { endpoints: { login, signup, confirm, resetPassword } } = authApi;
